module.exports = __webpack_public_path__ + "static/media/banner-apple-ppfa@3x.0200b2da.png";